import { Component, DestroyRef, ElementRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { SidebarComponent } from '../components/sidebar/sidebar.component';
import { IconComponent } from '../components/icon/icon.component';
import { CommonModule } from '@angular/common';
import { HelpButtonComponent } from '../components/help-button/help-button.component';
import { OrganizationSwitcherComponent } from '../components/organization-switcher/organization-switcher.component';
import { NotificationBellComponent } from '../../notifications/components/notification-bell.component';
import { GlobalUploadStatusComponent } from '../components/global-upload-status/global-upload-status.component';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [RouterOutlet, SidebarComponent, IconComponent, CommonModule, HelpButtonComponent, OrganizationSwitcherComponent, NotificationBellComponent, GlobalUploadStatusComponent],
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent {
  environmentName = environment.environmentName;
  isProduction = environment.production && environment.environmentName === 'PROD';

  private host = inject<ElementRef<HTMLElement>>(ElementRef);

  constructor() {
    // KAN-670: this shell stays mounted across page changes (one parent route in
    // app.routes.ts). The phone/tablet menu is a DaisyUI focus menu - it stays
    // open while focus is inside it, and the link just tapped keeps focus after
    // the route changes. Rebuilding the shell used to drop that focus by accident.
    inject(Router).events
      .pipe(filter(event => event instanceof NavigationEnd), takeUntilDestroyed(inject(DestroyRef)))
      .subscribe(() => this.closeMobileMenu());
  }

  private closeMobileMenu(): void {
    const focused = document.activeElement;
    const menu = this.host.nativeElement.querySelector('[data-testid="main-layout-mobile-nav"] .dropdown');
    if (focused instanceof HTMLElement && menu?.contains(focused)) {
      focused.blur();
    }
  }
}
